import * as ko from "knockout";

export class task_signature_data {
  technician: KnockoutObservable<string>;
  customer: KnockoutObservable<string>;

  constructor(item?: task_signature_data | any) {
    this.technician = ko.observable(item?.technician);
    this.customer = ko.observable(item?.customer);
  }
}
